
export const PageTitle = (props: any) => {
  const { title } = props;
  return (
    <h1 className=" text-[24px] font-bold text-gray-900 " >{title}</h1>
  )
}

export const PageTitleSecondary = (props: any) => {
  const { title } = props;
  return (
    <p className=" text-gray-600 mt-1 font-semibold text-[14px]  " >{title}</p>
  )
}


export const DashboardCard = (props: any) => {
  const { title, subtitle, icon, value } = props;
  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      <div className="flex items-center justify-between">
        <h3 className="tracking-tight text-sm font-medium text-gray-900 ">{title}</h3>
        <p className="fill-gray-500" > {icon} </p>
      </div>

      <p className="text-2xl font-bold mt-5">{value}</p>

      <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>

    </div>
  )
}

export const ChartCard = (props: any) => {
  const { title, subtitle, icon, icon2, title3, onClick } = props;
  return (
    <div
      className="bg-white p-4 rounded-lg shadow-md cursor-pointer hover:bg-gray-100 transition-all duration-300 "
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}

    >
      <div className="flex items-center ">
        <p className="fill-gray-500" > {icon} </p>
        <h2 className="text-md font-semibold leading-none tracking-tight flex items-center ms-2">{title}</h2>
      </div>

      <div className="text-xs text-muted-foreground mt-1">{subtitle}</div>

      <div className="flex items-center mt-2">
        <p className="fill-gray-500" > {icon2} </p>
        <p className="text-xs text-muted-foreground ms-2">{title3}</p>
      </div>

    </div>
  )
}

export const ActionCard = (props: any) => {
  const { icon, title, route, navigate } = props;
  return (
    <div
      className=" h-fit border-[1px] border-gray-200 py-4 rounded-md cursor-pointer hover:bg-gray-100 transition-all duration-300 "
      onClick={() => { navigate(route); }}
    >
      <p className="text-center">{icon}</p>
      <p className="text-center mt-4">{title}</p>
    </div>
  )
}

export const TagsCustom = (props: any) => {

  const { text, type } = props;

  let className = '';
  if (type === 'success') {
    className = 'bg-green-100 text-[#166534]';
  } else if (type === 'error') {
    className = 'bg-red-100 text-[#ef4444]';
  } else if (type === 'gray') {
    className = 'bg-gray-100 text-gray-700';
  } else {
    className = 'bg-gray-100 text-gray-700';
  }

  return (
    <div className={`h-fit w-fit p-2 leading-[1] text-[12px] font-semibold rounded-lg ${className}`}>{text}</div>
  )
}

export const RecentUploads = (props: any) => {
  const { icon, title, subtitle, status } = props;
  return (
    <div className="flex justify-between items-center p-4 bg-[#f9fafb] rounded-lg">

      <div className="flex items-center gap-2">
        <div className="w-fit h-fit"> {icon} </div>
        <div className="flex flex-col">
          <p className="text-sm font-semibold">{title}</p>
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        </div>
      </div>

      <div className="flex items-center ">
        <TagsCustom type={status} text={status} />
      </div>

    </div>
  )
}

export const BasicCard = (
  {
    children,
    className,
    title,
    subtitle,
    titleIcon,
    contentRight,
    titleCls = ""
  }: { children: React.ReactNode, className?: string, title?: string, subtitle?: string, titleIcon?: React.ReactNode, contentRight?: React.ReactNode, titleCls?: string }) => {
  return (
    <div className={` rounded-lg border bg-card text-card-foreground shadow-sm p-6 ${className} `}>
      {title && subtitle && contentRight &&
        <div className="mb-4">
          <div>
            {title && <div className={` text-xl font-semibold leading-none tracking-tight ${titleCls} `}> {titleIcon} {title}</div>}
            {subtitle && <p className={` text-sm text-muted-foreground ${title ? " mt-2 " : " mt-0 "} `}>{subtitle}</p>}
          </div>
          <div className=""> {contentRight} </div>
        </div>
      }
      {children}
    </div>
  )
}


export const BasicCard2 = (
  {
    children,
    className,
    title,
    subtitle,
    titleIcon,
    contentRight,
    titleCls = ""
  }: { children: React.ReactNode, className?: string, title?: string, subtitle?: string, titleIcon?: React.ReactNode, contentRight?: React.ReactNode, titleCls?: string }) => {
  return (
    <div className={` rounded-lg border bg-card text-card-foreground shadow-sm p-6 ${className} `}>
      {title && subtitle && 
        <div className="mb-4">
          <div>
            {title && <div className={` text-xl font-semibold leading-none tracking-tight ${titleCls} `}> {titleIcon} {title}</div>}
            {subtitle && <p className={` text-sm text-muted-foreground ${title ? " mt-2 " : " mt-0 "} `}>{subtitle}</p>}
          </div>
          {contentRight && <div className=""> {contentRight} </div>}
        </div>
      }
      {children}
    </div>
  )
}